import React from 'react'
import { Text, TextProps, TextStyle } from 'react-native'
import { FONT_FAMILY } from '../../common/styles'

interface PropsType {
    style?: TextStyle,
    text: string | number,
    props?: TextProps
}

const NSText = ({ style, text, props }: PropsType) => {

    return (
        <Text style = {{ fontFamily: FONT_FAMILY.notosans, ...style }} { ...props }>{ text }</Text>
    )

}

export default NSText
